module.exports = __webpack_public_path__ + "img/ar_fee_w_s.d7145e27.svg";